import { render, staticRenderFns } from "./healthtrackingNextDetail.vue?vue&type=template&id=83a14506&"
import script from "./healthtrackingNextDetail.vue?vue&type=script&lang=js&"
export * from "./healthtrackingNextDetail.vue?vue&type=script&lang=js&"
import style0 from "./healthtrackingNextDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports